<template>
  <v-card
    class="poistenie-banner pl-30px mt-6 pr-72px pt-30px akciova-ponuka"
    @click="handleSelect"
  >
    <v-img
      class="banner-image"
      :width="522"
      :src="require(`../../assets/img/banner-bckg${$vuetify.theme.dark ? '' : '-light'}.png`)"
    ></v-img>
    <div class="d-flex banner-content">
      <div class="mr-50px">
        <v-img class="banner-logo" :src="getImage(value)" height="48" width="100"></v-img>
      </div>
      <text-group invert smallHeader xl :utext="''" :btext="value.displayMember"></text-group>
      <div class="mr-auto mt-3px">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="btn-help" v-bind="attrs" v-on="modifyOnEvent(on, value.valueMember)">
              mdi-help-circle
            </v-icon>
          </template>
          <span>{{ toolTipMessage }}</span>
          <table>
            <tbody>
              <tr v-for="(datum, i) in tooltipData" :key="i">
                <td>{{ datum.popis }}</td>
                <td>{{ datum.hodnota }}</td>
              </tr>
            </tbody>
          </table>
        </v-tooltip>
        <v-icon v-show="addButton" class="btn-help ml-5px" @click.stop="addButtonClicked()">
          mdi-plus-circle
        </v-icon>
      </div>
      <!-- <text-group
        :gap="4"
        class="mt-5px"
        smallHeader
        utext="Poistné sadzby"
        btext="KASKO, PZP"
      ></text-group> -->
      <text-group
        :gap="4"
        class="ml-30px mt-5px"
        smallHeader
        utext="Spoluúčasť"
        :btext="value.spoluucast"
      ></text-group>
      <text-group
        class="ml-30px mt-5px"
        :gap="4"
        smallHeader
        utext="Ročné poistné"
        :btext="value.poistne_rocne.toEurString()"
      ></text-group>
    </div>
  </v-card>
</template>
<script>
import TextGroup from '../basic/TextGroup';
import { poistenieMixin } from '../../mixins/poistenieMixin';

export default {
  mixins: [poistenieMixin],
  components: {
    TextGroup,
  },
  data() {
    return {
      data: this.value ?? {
        nazov: 'Žiadné dáta',
        popis: 'Žiadné dáta',
        poistovna: 'no_image',
      },
    };
  },
};
</script>
